import Alpine from 'alpinejs';
import axios from '../../config/axios.js';

function money(n) {
  return 'Rp ' + Number(n || 0).toLocaleString('id-ID');
}

function createSurangStart() {
  return {
    loading: true,
    creating: false,
    productKey: '',
    product: null,
    templates: [],
    boardMode: 'blank',
    templateId: null,
    lengthCm: 50,
    widthCm: 30,
    qty: 1,
    variantIds: {},
    quote: null,
    quoting: false,
    pricingChannel: 'surang',

    get widthMm() {
      return Math.max(1, Number(this.lengthCm) || 0) * 10;
    },

    get heightMm() {
      return Math.max(1, Number(this.widthCm) || 0) * 10;
    },

    async init() {
      if (!Alpine.store('auth')?.isLoggedIn) {
        window.location.href = '/login?redirect=' + encodeURIComponent(window.location.pathname);
        return;
      }
      this.productKey = this.$el.dataset.productKey || '';
      this.pricingChannel = this.$el.dataset.pricingChannel
        || new URLSearchParams(window.location.search).get('channel')
        || 'surang';
      await this.load();
    },

    selectedVariantIds() {
      return Object.values(this.variantIds).filter(Boolean);
    },

    syncMmFromCm() {
      // getters derive mm from cm; trigger quote refresh after input
      this.refreshQuote();
    },

    ukuran() {
      const unit = String(this.product?.price_unit || 'pcs').toLowerCase();
      const panjang = Math.max(0, Number(this.lengthCm) || 0);
      const lebar = Math.max(0, Number(this.widthCm) || 0);
      if (unit === 'meter') {
        return `${(panjang / 100).toFixed(4)}x${(lebar / 100).toFixed(4)}`;
      }
      return `${panjang}x${lebar}cm`;
    },

    sizeLabel() {
      return `${this.lengthCm} × ${this.widthCm} cm`;
    },

    async load() {
      this.loading = true;
      try {
        const { data } = await axios.get(`/api/v1/surang/products/${this.productKey}`);
        this.product = data.data;
        const board = this.product.default_board || {};
        this.lengthCm = Math.round((board.width_mm || 500) / 10);
        this.widthCm = Math.round((board.height_mm || 300) / 10);
        this.qty = Math.max(1, this.product.min_order || 1);
        (this.product.variants || []).forEach((g) => {
          if (g.options?.length) this.variantIds[g.type] = g.options[0].id;
        });
        const tpl = await axios.get(`/api/v1/surang/products/${this.product.id}/templates`);
        this.templates = tpl.data.data?.templates || [];
        await this.refreshQuote();
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Produk tidak tersedia untuk SURANG.', 'error');
      } finally {
        this.loading = false;
      }
    },

    async refreshQuote() {
      if (!this.product) return;
      this.quoting = true;
      try {
        const { data } = await axios.post('/api/v1/surang/quote', {
          product_id: this.product.id,
          ukuran: this.ukuran(),
          qty: this.qty,
          variant_ids: this.selectedVariantIds(),
          pricing_channel: this.pricingChannel,
        });
        this.quote = data.data;
      } catch (e) {
        this.quote = null;
        window.toast?.(e.response?.data?.message || 'Gagal hitung harga.', 'error');
      } finally {
        this.quoting = false;
      }
    },

    selectTemplate(t) {
      if (t.locked) {
        window.toast?.(t.lock_reason || 'Template terkunci.', 'error');
        return;
      }
      this.boardMode = 'template';
      this.templateId = t.id;
      this.refreshQuote();
    },

    chooseBlank() {
      this.boardMode = 'blank';
      this.templateId = null;
    },

    async create() {
      if (!this.product) return;
      this.creating = true;
      try {
        const { data } = await axios.post('/api/v1/surang/projects', {
          product_id: this.product.id,
          board_mode: this.boardMode,
          template_id: this.boardMode === 'template' ? this.templateId : null,
          width_mm: this.widthMm,
          height_mm: this.heightMm,
          qty: this.qty,
          variant_ids: this.selectedVariantIds(),
          ukuran: this.ukuran(),
          pricing_channel: this.pricingChannel,
        });
        window.toast?.(data.message || 'Proyek dibuat.', 'success');
        window.location.href = `/surang/editor/${data.data.id}`;
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal membuat proyek.', 'error');
      } finally {
        this.creating = false;
      }
    },

    money,
  };
}

Alpine.data('surangStart', createSurangStart);
